import Vue from 'vue';

import RtHeader from '../packages/header/src/main';
import RtContent from '../packages/content/src/main';
import RtToolbar from '../packages/toolbar/src/main';
import RtQuery from '../packages/query/src/main';
import RtGrid from '../packages/grid/src/main';
import RtPicklist from '../packages/picklist/src/main';
import RtButton from '../packages/button/src/main';
import RtSection from '../packages/section/src/main';
import RtNav from '../packages/nav/src/nav';
import RtNavItem from '../packages/nav/src/nav-item';
import RtPortalIcon from '../packages/icon/index'
//Lookup
import RtLookup from '../packages/lookup/src/lookup';
import RtLookupDialog from '../packages/lookup/src/lookup-dialog';
//Vehicle Selector
import RtVehicleSelector from '../packages/vehicle-selector/src/vehicle-selector';
import RtVehicleDialog from '../packages/vehicle-selector/src/vehicle-dialog';
//Common Selector
import RtCommonSelector from '../packages/common-selector/src/common-selector';
import RtCommonDialog from '../packages/common-selector/src/common-dialog';
//Excel导入
import RtExcelImportDialog from '../packages/excel-import/src/excel-import-dialog';
import RtExcelImport from '../packages/excel-import/src/excel-import';
//流程提交
import RtFlowSubmitDialog from '../packages/flow/src/submit-dialog';
//审批进度
import RtApprovalProgress from '../packages/approval/src/progress';
import RtApprovalProgressDialog from '../packages/approval/src/progress-dialog';

import RtFileList from './file/src/file-list';
import XpcComponents from "vue-xpc/src/components";

// 通用表单折叠组件
import RtSearchFilter from '../packages/searchFilter/index';
// 通用面包屑组件
import RtBreadBar from '../packages/breadBar/index';
// 弹出框
import RtTooltip from '../packages/tooltip/index';


var components = [
    RtHeader,
    RtContent,
    RtToolbar,
    RtQuery,
    RtGrid,
    RtPicklist,
    RtButton,
    RtSection,
    RtNav,
    RtNavItem,
    RtLookup,
    RtLookupDialog,
    RtVehicleSelector,
    RtVehicleDialog,
    RtCommonSelector,
    RtCommonDialog,
    RtExcelImportDialog,
    RtExcelImport,
    RtFlowSubmitDialog,
    RtApprovalProgress,
    RtApprovalProgressDialog,
    RtFileList,
    RtPortalIcon,
    RtSearchFilter,
    RtBreadBar,
    RtTooltip
];


export default {
    install: function (Vue, opts) {
        Vue.use(XpcComponents, {
            config: {
              componentPrefix: "Rt",
              address:{autoLoad:false}
            },
        });
        components.map(function (component) {
            Vue.component(component.name, component);
        });


    }
}



//////////////////
// WEBPACK FOOTER
// ./packages/index.js
// module id = 1517
// module chunks = 116